import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-4961636a"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  className: "main"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  className: "info-main"
}, [/*#__PURE__*/_createElementVNode("p", {
  className: "info-title"
}, "使用目的"), /*#__PURE__*/_createElementVNode("div", {
  className: "info-desc"
}, "用于埋点统计分析、定位用户问题、安全风控")], -1));

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  className: "info-main"
}, [/*#__PURE__*/_createElementVNode("p", {
  className: "info-title"
}, "使用场景"), /*#__PURE__*/_createElementVNode("div", {
  className: "info-desc"
}, "用户使用APP时")], -1));

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  className: "info-main"
}, [/*#__PURE__*/_createElementVNode("p", {
  className: "info-title"
}, "收集主体"), /*#__PURE__*/_createElementVNode("div", {
  className: "info-desc"
}, "本APP")], -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_top_title = _resolveComponent("top-title");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", null, [_createVNode(_component_top_title, {
    onBack: $setup.back,
    title: "国际移动设备身份码"
  }, null, 8, ["onBack"]), _hoisted_2, _hoisted_3, _hoisted_4])]);
}